import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "./AuthContext";
import AdminStats from "./AdminStats";
import GameLicenseForm from "./AdminDash";
import LicenseTable from "./AdminUpdate";
import AdminCreateUser from "./AdminCreateUser";
import AdminUsersList from "./AdminUsersList";

const AdminPage = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const [activePage, setActivePage] = useState('users');
  const [selectedUserForLicense, setSelectedUserForLicense] = useState(null);

  const handleSignOut = () => {
    logout();
    navigate('/login');
  };

  const handleSelectCreateLicense = (userId) => {
    setSelectedUserForLicense(userId);
    setActivePage('generate');
  };

  return (
    <div className="dashboard">
      <aside className="sidebar-admin">
        <div style={{ padding: '20px', color: '#fff', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <img src="/virsatlogo.png" alt="Virsat Logo" className='image-align' style={{ maxWidth: '140px' }} />
          <div style={{ marginTop: '10px', fontSize: '13px', color: '#a0aec0' }}>
            Logged in as:<br />
            <strong style={{ color: '#fff' }}>{user?.email}</strong>
          </div>
        </div>

        <nav className="menu">
          <ul>
            <li>
              <button
                className={activePage === 'users' ? 'active' : ''}
                onClick={() => setActivePage('users')}
              >
                User Management
              </button>
            </li>
            <li>
              <button
                className={activePage === 'create-user' ? 'active' : ''}
                onClick={() => setActivePage('create-user')}
              >
                Create New User
              </button>
            </li>
            <li>
              <button
                className={activePage === 'generate' ? 'active' : ''}
                onClick={() => {
                  setSelectedUserForLicense(null);
                  setActivePage('generate');
                }}
              >
                Generate License
              </button>
            </li>
            <li>
              <button
                className={activePage === 'modify' ? 'active' : ''}
                onClick={() => setActivePage('modify')}
              >
                Manage Licenses
              </button>
            </li>
            <li>
              <button
                className={activePage === 'stats' ? 'active' : ''}
                onClick={() => setActivePage('stats')}
              >
                Platform Stats
              </button>
            </li>
            <li style={{ marginTop: '15px' }}>
              <button
                onClick={() => navigate('/dashboard')}
                style={{ backgroundColor: '#214DA0', color: '#fff', fontWeight: 'bold' }}
              >
                User Dashboard
              </button>
            </li>
            <li style={{ marginTop: '15px' }}>
              <button
                onClick={handleSignOut}
                style={{ backgroundColor: '#e53e3e', color: '#fff', fontWeight: 'bold' }}
              >
                Sign Out
              </button>
            </li>
          </ul>
        </nav>
      </aside>

      <main className="content" style={{ padding: '30px', flex: 1, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
        {activePage === 'users' && (
          <div className="purchase-form">
            <AdminUsersList onSelectCreateLicense={handleSelectCreateLicense} />
          </div>
        )}

        {activePage === 'create-user' && (
          <div className="purchase-form">
            <AdminCreateUser
              onUserCreated={() => {
                setActivePage('users');
              }}
            />
          </div>
        )}

        {activePage === 'generate' && (
          <div className="purchase-form">
            <GameLicenseForm initialUserId={selectedUserForLicense} />
          </div>
        )}

        {activePage === 'modify' && (
          <div className="purchase-form">
            <LicenseTable />
          </div>
        )}

        {activePage === 'stats' && (
          <div className="purchase-form">
            <AdminStats />
          </div>
        )}
      </main>
    </div>
  );
};

export default AdminPage;